<!-- <ngx-loading-bar [color]="'#7366ff'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar> -->
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>